/**
 * Copyright (C) 2025 Checkmk GmbH - License: GNU General Public License v2
 * This file is part of Checkmk (https://checkmk.com). It is subject to the terms and
 * conditions defined in the file COPYING, which is part of this source code package.
 */

export enum Graph {
  SITE_OVERVIEW = 'SITE_OVERVIEW',
  HOST_STATE = 'HOST_STATE',
  HOST_STATE_SUMMARY = 'HOST_STATE_SUMMARY',
  HOST_STATISTICS = 'HOST_STATISTICS'
}
